'use client';

import React from 'react';
import { Props } from './types';
import { TasticComponentProps } from '../types';
import CollectionStatement from '@/components/organisms/collection-statement';

const CollectionStatementTastic = ({ data }: any) => {
  const CollectionStatementdata = data?.data?.dataSource;
  
  return (
    <div>
      <CollectionStatement CollectionStatementdata={CollectionStatementdata} />
    </div>
  );
};

export default CollectionStatementTastic;
